<template>
  <div class="cotizador-viaje" :class="{ 'is-embedded': isEmbedded }">
    <Header></Header> 
    <div class="p-0 m-0">
      <div class="d-flex justify-content-center">
        <div class="bg-white p-3 p-md-3 rounded-lg w-100 w-md-75 cotizador-card" v-if="verTipoViaje == 1" style="border-radius: 1px;">
           <h2 class="fw-bold mb-3 text-center title-cotizador">Cotiza tu asistencia de viaje Aquí.</h2>
          
          <div class="row g-3 mb-2 form-row"> 
             <div class="col-md-4"> 
              <div class="form-floating">
                <select class="form-select form-select-sm" id="floatingOrigen" aria-label="Origen" v-model="cotizar.origen">
                  <option :value="null" selected>Seleccione origen</option>
                  <option v-for="c in contries" :key="c.isoCountry" :value="c.isoCountry">{{c.description}}</option>
                </select>
                <label for="floatingOrigen">Origen</label>
              </div>
            </div>
             <div class="col-md-4"> 
              <div class="form-floating">
                <select class="form-select form-select-sm" id="floatingDestino" aria-label="Destino" v-model="cotizar.destino">
                  <option :value="null" selected>Seleccione destino</option>
                  <option v-for="t in territories" :key="t.idTerritory" :value="t.idTerritory">{{t.territory}}</option>
                </select>
                <label for="floatingDestino">Destino</label>
              </div>
            </div>
            <div class="col-md-4"> 
              <div class="form-floating datepicker-small">
                 <VueDatePicker
                  v-model="cotizar.fecha"
                  id="floatingSalida"
                  class="form-control form-control-sm datepicker-custom-size"
                  :locale="esLocale"
                  :disabled-dates="disabledDates"
                  :enable-time-picker="false"
                  :auto-apply="true"
                  range
                  placeholder=" " 
                  @closed="validarFecha"
                  :input-class-name="'dp-custom-input-style'"
                  :teleport="false" /> <label for="floatingSalida">Fecha de inicio y fin</label>
              </div>
            </div>
          </div>

          <div class="row g-3 mb-2 align-items-center form-row">
             <div class="col-md-6"> 
              <div class="dropdown">
                 <button class="btn btn-outline-secondary dropdown-toggle w-100 text-start d-flex justify-content-between align-items-center btn-sm" type="button" id="dropdownPasajeros" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" :class="{'border-danger text-danger': edadInvalida}">
                   <span>Pasajeros</span>
                </button>
                 <div class="dropdown-menu p-3 w-100" aria-labelledby="dropdownPasajeros">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <span class="fw-bold">Cantidad de pasajeros</span>
                    <div>
                      <button class="btn btn-danger btn-sm me-2" @click.prevent="masmenosPasajeros('-', $event)" :disabled="numeroPasajeros <= 1">-</button>
                      <span class="mx-1">{{numeroPasajeros}}</span>
                      <button class="btn btn-primary btn-sm ms-2" @click.prevent="masmenosPasajeros('+', $event)" :disabled="numeroPasajeros >= 8">+</button>
                    </div>
                  </div>
                  <div class="row g-2 mb-2 align-items-center" v-for="(pasajero, index) in cotizar.pasajeros" :key="pasajero.id">
                    <div class="col-6">
                      <label :for="'edadPasajero' + pasajero.id" class="form-label small mb-0">Edad Pasajero {{ index + 1 }}</label>
                    </div>
                    <div class="col-6">
                      <input type="number" class="form-control form-control-sm" :id="'edadPasajero' + pasajero.id" v-model.number="pasajero.edad" placeholder="Edad" min="0" max="120" :class="{'border-danger': edadInvalida && pasajero.edad === ''}">
                    </div>
                  </div>
                </div>
              </div>
            </div>
             <div class="col-md-6"> 
              <div class="form-floating">
                <input type="text" id="floatingDias" class="form-control form-control-sm" v-model="cotizar.noDias" disabled placeholder=" ">
                <label for="floatingDias">No. Días</label>
              </div>
            </div>
          </div>

          <div class="row g-3 mb-3 form-row">
            <div class="col-md-6">
              <div class="form-floating">
                <input type="email" id="floatingCorreo" class="form-control form-control-sm" v-model="cotizar.correo" placeholder="Correo">
                <label for="floatingCorreo">Correo</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <input type="tel" id="floatingCelular" class="form-control form-control-sm" v-model="cotizar.celular" placeholder="Celular">
                <label for="floatingCelular">Celular</label>
              </div>
            </div>
          </div>

          <div class="alert alert-danger mt-3" role="alert" v-if="msgError !== ''"> {{msgError}}
          </div>
          <div class="text-center mt-3"> <button class="btn btn-zebra btn-cotizar" @click.prevent="generarCotizacion()">COTIZAR</button>
          </div>
        </div> 
        
        <template v-if="verTipoViaje == 2">
          <div class="bg-white p-4 p-md-5 rounded-lg w-100 w-md-75" style="border-radius: 10px;">
            <div class="d-flex justify-content-between align-items-center mb-4">
                 <h2 class="fw-bold" style="color: #32A5AB;">Selecciona un tipo de viaje</h2>
                 <button class="btn btn-sm btn-outline-secondary" @click.prevent="verTipoViaje = 1">Volver</button>
            </div>

            <div class="row g-3 justify-content-center">
                 <template v-if="visibleCategories.length > 0">
                     <div v-for="i in visibleCategories"
                          :key="i.id"
                          class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 d-flex align-items-stretch" style="cursor: pointer;"
                          @click.prevent="verPolizas(i.id, i.category)">

                         <div class="card h-100 text-center card-hover-effect">
                             <div class="card-img-top-placeholder bg-light d-flex align-items-center justify-content-center" style="height: 150px; border-bottom: 1px solid #eee;">
                                 <i class="fas fa-suitcase-rolling fa-3x text-secondary"></i> </div>
                             <div class="card-body d-flex flex-column">
                                 <h5 class="card-title fw-bold">{{ i.category }}</h5>
                                 <button class="btn btn-sm btn-zebra mt-auto">Seleccionar</button> </div>
                         </div>
                     </div>
                 </template>
                 <div v-else class="col-12">
                     <div class="alert alert-warning text-center" role="alert">
                       No se encontraron tipos de viaje que coincidan con tu selección. Intenta ajustar las fechas o edades.
                       <button class="btn btn-link p-0 ms-2" @click.prevent="verTipoViaje = 1">Modificar búsqueda</button>
                     </div>
                 </div>
            </div> 
          </div> 
        </template> 
      </div> 
      </div> 
  </div>
</template>

<script>
import { es } from 'date-fns/locale';
import Header from '@/components/components/Header';

export default {
  components: {
    Header,
  },
  data() {
    return {
      esLocale: es,
      verTipoViaje: 1,
      msgError: '',
      cotizacionPendienteKey: 'zebra_wp_cotizacion_pendiente',
      wpResumeParam: process.env.VUE_APP_WP_COTIZAR_RESUME_PARAM || 'zebra_quote_resume',
      wpCotizarEventName: process.env.VUE_APP_WP_COTIZAR_EVENT || 'zebra.cotizador.cotizar',
      wpTargetOrigin: process.env.VUE_APP_WP_TARGET_ORIGIN || '*',
      cotizacionEnProceso: false,
      isEmbedded: false,
      cotizar: {
        origen: 'CO',
        destino: null,
        fecha: null,
        noDias: null,
        correo: '',
        celular: '',
        pasajeros: [
          { id: 1, edad: "" } 
        ],
        idCategoria: null,
        nombreCategoria: '',
        origenNombre: '',
        origenId: '',
        destinoNombre: '',
        fi: null,
        ff: null,
        cantidadPasajeros: 1
      },
      contries: [],
      categories: [],
      visibleCategories: [],
      territories: [],
      numeroPasajeros: 1,
      edadInvalida: false,
    }
  },
  name: 'CotizadorViaje',
  async mounted() {
    try {
      this.isEmbedded = window.self !== window.top;
    } catch (error) {
      this.isEmbedded = true;
    }
    await Promise.all([
      this.getContries(),
      this.getTerritories()
    ]);
    await this.reanudarCotizacionPendiente();
  },

  methods: {
    breakOutOfIframe(url) {
      if (window.top !== window.self) {
        window.top.location.href = url;
      } else {
        window.location.href = url;
      }
    },
    openInNewWindow() {
      const url = 'https://wtapruebas.zebrasistencia.com/';
      const newWindow = window.open(url, '_blank');
      if (newWindow) {
        newWindow.focus();
      } else {
        alert('El navegador bloqueó la apertura de una nueva ventana. Intenta deshabilitar el bloqueador de popups.');
      }
    },
    forceTopWindow(url) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_top';
      document.body.appendChild(a); 
      a.click();
      document.body.removeChild(a);
    },
    buildCotizacionSnapshot() {
      const fecha = Array.isArray(this.cotizar.fecha) ? this.cotizar.fecha : [];
      return {
        origen: this.cotizar.origen,
        destino: this.cotizar.destino,
        fechaInicio: fecha[0] || null,
        fechaFin: fecha[1] || null,
        noDias: this.cotizar.noDias,
        cantidadPasajeros: this.cotizar.cantidadPasajeros,
      };
    },
    guardarCotizacionPendiente() {
      try {
        const payload = {
          createdAt: Date.now(),
          cotizar: JSON.parse(JSON.stringify(this.cotizar))
        };
        localStorage.setItem(this.cotizacionPendienteKey, JSON.stringify(payload));
      } catch (error) {
        console.error('No se pudo guardar la cotización pendiente:', error);
      }
    },
    limpiarCotizacionPendiente() {
      localStorage.removeItem(this.cotizacionPendienteKey);
    },
    obtenerCotizacionPendiente() {
      const raw = localStorage.getItem(this.cotizacionPendienteKey);
      if (!raw) {
        return null;
      }

      try {
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.cotizar) {
          return null;
        }

        const maxAgeMs = 1000 * 60 * 30;
        if (parsed.createdAt && (Date.now() - parsed.createdAt) > maxAgeMs) {
          this.limpiarCotizacionPendiente();
          return null;
        }

        return parsed.cotizar;
      } catch (error) {
        console.error('Cotización pendiente inválida:', error);
        this.limpiarCotizacionPendiente();
        return null;
      }
    },
    emitirEventoWordPressCotizar() {
      const eventPayload = {
        source: 'zebra-asistencia',
        event: this.wpCotizarEventName,
        timestamp: new Date().toISOString(),
        storageKey: this.cotizacionPendienteKey,
        resumeParam: this.wpResumeParam,
        cotizacion: this.buildCotizacionSnapshot()
      };

      try {
        window.dispatchEvent(new CustomEvent(this.wpCotizarEventName, { detail: eventPayload }));
      } catch (error) {
        console.error('No se pudo disparar evento local de cotización:', error);
      }

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(eventPayload, this.wpTargetOrigin);
      }
    },
    validarDatosCotizacion() {
      if (!this.cotizar.origen || !this.cotizar.destino) {
        this.msgError = 'Debes seleccionar un origen y un destino.';
        return false;
      }
      if (!this.cotizar.fecha || this.cotizar.fecha.length !== 2 || !this.cotizar.noDias) {
        this.msgError = 'Debes seleccionar un rango de fechas válido (inicio y fin).';
        return false;
      }
      if (!this.cotizar.correo || !/\S+@\S+\.\S+/.test(this.cotizar.correo)) {
        this.msgError = 'Por favor, ingresa un correo electrónico válido.';
        return false;
      }
      if (!this.cotizar.celular) {
        this.msgError = 'Por favor, ingresa tu número de celular.';
        return false;
      }
      if (this.cotizar.pasajeros.some(p => p.edad === "" || p.edad === null || isNaN(parseInt(p.edad)) || parseInt(p.edad) < 0 || parseInt(p.edad) > 120)) {
        this.msgError = 'Debes ingresar una edad válida (entre 0 y 120) para todos los pasajeros.';
        this.edadInvalida = true;
        return false;
      }
      return true;
    },
    async reanudarCotizacionPendiente() {
      const resumeValue = this.$route?.query?.[this.wpResumeParam];
      const shouldResume = resumeValue === '1' || resumeValue === 'true';
      if (!shouldResume) {
        return;
      }

      const cotizacionPendiente = this.obtenerCotizacionPendiente();
      if (!cotizacionPendiente) {
        return;
      }

      const pasajeros = Array.isArray(cotizacionPendiente.pasajeros) && cotizacionPendiente.pasajeros.length > 0
        ? cotizacionPendiente.pasajeros
        : [{ id: 1, edad: "" }];

      this.cotizar = {
        ...this.cotizar,
        ...cotizacionPendiente,
        pasajeros
      };
      this.numeroPasajeros = pasajeros.length;
      this.cotizar.cantidadPasajeros = this.numeroPasajeros;

      if (!this.cotizar.noDias && this.cotizar.fecha && this.cotizar.fecha.length === 2) {
        this.getCantidadDias(this.cotizar.fecha);
      }

      await this.generarCotizacion({ omitirEventoWordPress: true });
    },

    validarFecha() {
        this.msgError = '';
      if (this.cotizar.fecha && this.cotizar.fecha.length === 2) {
        if (new Date(this.cotizar.fecha[1]) < new Date(this.cotizar.fecha[0])) {
             this.msgError = 'La fecha de fin no puede ser anterior a la fecha de inicio.';
             this.cotizar.fecha = null;
             this.cotizar.noDias = null;
        } else {
             this.getCantidadDias(this.cotizar.fecha);
        }
      } else {
        this.cotizar.noDias = null;
      }
    },

    getCantidadDias(data) {
      if (!data || data.length !== 2) return 0;
      const salida = new Date(data[0]).getTime();
      const regreso = new Date(data[1]).getTime();
      const diff = regreso - salida;
      const dias = Math.max(0, diff / (1000 * 60 * 60 * 24)) + 1;
      this.cotizar.noDias = Math.round(dias);
    },

    masmenosPasajeros(operacion, event) {
        if(event) event.stopPropagation();

        if (operacion === '-') {
            if (this.numeroPasajeros > 1) {
                this.numeroPasajeros--;
                this.cotizar.pasajeros.pop();
            }
        } else {
            if (this.numeroPasajeros < 8) {
                this.numeroPasajeros++;
                this.cotizar.pasajeros.push({
                    id: this.numeroPasajeros,
                    edad: ""
                });
            }
        }
        this.cotizar.cantidadPasajeros = this.numeroPasajeros;
    },

    async generarCotizacion(options = {}) {
      const { omitirEventoWordPress = false } = options;
      if (this.cotizacionEnProceso) {
        return;
      }

      this.msgError = '';
      this.edadInvalida = false;
      if (!this.validarDatosCotizacion()) {
        return;
      }

      if (!omitirEventoWordPress) {
        this.guardarCotizacionPendiente();
        this.emitirEventoWordPressCotizar();
      }

      this.cotizacionEnProceso = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cotizador.clic'
      });
      try {
        const params = { "paginate": false }; 
        const response = await this.$root.post('plans/list', params);

        if (!response || !response.data || !response.data.data) {
             throw new Error('Respuesta inválida de la API de planes');
        }

        const allPlans = response.data.data;
        const { destino, noDias, pasajeros } = this.cotizar;
        const plans = allPlans.filter(plan => {
          const territoryMatch = plan.restrictions?.availableTerritory === destino;
          if (!territoryMatch) return false;
          const minDays = parseInt(plan.minDays);
          const maxDays = parseInt(plan.maxDays);
          const diasValidos = (!isNaN(minDays) && !isNaN(maxDays)) &&
                            ((minDays === 0 && maxDays >= noDias) ||
                             (minDays > 0 && minDays <= noDias && maxDays >= noDias));
          if (!diasValidos) return false;

          const minAge = parseInt(plan.minAge);
          const maxAge = parseInt(plan.maxAge);
          if (isNaN(minAge) || isNaN(maxAge)) return false; 

          const edadesValidas = pasajeros.every(pasajero => {
            const edad = parseInt(pasajero.edad);
            return edad >= minAge && edad <= maxAge;
          });

          return edadesValidas;
        });
        const categoriesIds = [...new Set(plans.map(plan => plan.idCategory))];
        localStorage.setItem("filteredPlans", JSON.stringify(plans));
        await this.getCategorias(categoriesIds);
        if (this.visibleCategories.length > 0) {
          this.verTipoViaje = 2;
          this.limpiarCotizacionPendiente();
        } else {
             this.msgError = "No se encontraron planes de asistencia que coincidan con los criterios de tu viaje (destino, fechas, edades).";
        }
      } catch (error) {
        console.error('Error al generar cotización o filtrar planes:', error);
        this.msgError = 'Ocurrió un error al buscar los planes. Por favor, inténtalo de nuevo más tarde.';
         if (error.response) { 
              console.error("Detalle del error API:", error.response.data);
         }
      } finally {
        this.cotizacionEnProceso = false;
      }
    },
    disabledDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    async getContries() {
      try {
        const response = await this.$root.get('generals/countries');
        if (!response || !response.data) throw new Error("Respuesta inválida de API Countries");

        const contriesApi = response.data;
        const colombiaIndex = contriesApi.findIndex(country => country.isoCountry === 'CO');
        if (colombiaIndex > -1) {
          const colombia = contriesApi.splice(colombiaIndex, 1)[0];
          contriesApi.unshift(colombia);
        }
        this.contries = contriesApi;
         if (!this.cotizar.origen) {
             this.cotizar.origen = 'CO';
         }

      } catch (error) {
        console.error('Error al obtener los países:', error);
        this.contries = [];
        this.msgError = 'No se pudieron cargar los países de origen.';
      }
    },

    async getCategorias(categoriesFilterIds = []) {
      try {
        const response = await this.$root.get('plans/categories');
        if (!response || !response.data) throw new Error("Respuesta inválida de API Categories");
        this.categories = response.data;
        if (categoriesFilterIds.length > 0) {
            this.visibleCategories = this.categories.filter(cat => 
                categoriesFilterIds.includes(cat.id) && cat.id !== "4"
            );
        } else {
            this.visibleCategories = [];
        }

      } catch (error) {
        console.error('Error al obtener las categorías:', error);
        this.categories = [];
        this.visibleCategories = [];
        this.msgError = 'No se pudieron cargar los tipos de viaje.';
      }
    },

    async getTerritories() {
      try {
        const response = await this.$root.get('generals/territories');
         if (!response || !response.data) throw new Error("Respuesta inválida de API Territories");
        this.territories = response.data;
      } catch (error) {
        console.error('Error al obtener los territorios:', error);
        this.territories = [];
        this.msgError = 'No se pudieron cargar los destinos.';
      }
    },
    verPolizas(idCategoria, nombreCategoria) {
      localStorage.setItem("cotizar","");
      this.cotizar.idCategoria = idCategoria;
      this.cotizar.nombreCategoria = nombreCategoria;

      const origenData = this.contries.find(c => c.isoCountry === this.cotizar.origen);
      this.cotizar.origenNombre = origenData ? origenData.description : this.cotizar.origen;
      this.cotizar.origenId = origenData ? origenData.codePhone : ''; // O el ID que necesites

      const destinoData = this.territories.find(t => t.idTerritory === this.cotizar.destino);
      this.cotizar.destinoNombre = destinoData ? destinoData.territory : this.cotizar.destino;
      this.cotizar.fi = this.cotizar.fecha[0];
      this.cotizar.ff = this.cotizar.fecha[1];
      console.log(this.cotizar);
      localStorage.setItem("cotizar", JSON.stringify(this.cotizar));
      this.$router.push('/planes');
    }
  },
}
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
.title-cotizador {
  color: #32A5AB;
  font-size: clamp(1.9rem, 3vw, 2.35rem);
  line-height: 1.1;
}
.btn-cotizar {
  font-size: 1.05rem;
  padding: 0.45rem 1rem;
  min-width: 120px;
}
.form-row {
  --bs-gutter-x: 0.85rem;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.form-floating > .form-control-sm,
.form-floating > .form-select-sm {
  height: calc(1.35em + 0.95rem + 2px);
  padding: 0.88rem 0.7rem 0.35rem 0.7rem;
  min-height: calc(1.35em + 0.95rem + 2px);
  font-size: 0.9rem;
}

.form-floating > label {
  padding: 0.65rem 0.7rem;
  font-size: 0.8rem;
}

.form-floating > .form-control-sm:focus ~ label,
.form-floating > .form-control-sm:not(:placeholder-shown) ~ label,
.form-floating > .form-select-sm ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating.datepicker-small {
}

.form-floating .datepicker-custom-size {
  padding-top: 0.88rem;
  padding-bottom: 0.35rem;
  font-size: 0.9rem;
  height: 75%;
}
::v-deep .dp__input {
  border: none !important;
  padding-left: 0 !important; 
  padding-right: 0 !important;
  height: 100%; 
  font-size: 0.9rem;
  box-shadow: none !important; 
}
::v-deep .dp__icon {
  left: auto; 
  right: 0.5rem; 
  top: 50%;
  transform: translateY(-50%);
  width: 1rem; 
  height: 1rem; 
  pointer-events: none; 
}
.dropdown .btn-sm {
  height: calc(1.35em + 0.95rem + 2px);
  font-size: 0.9rem;
  padding: 0.38rem 0.7rem;
}
.cotizador-viaje.is-embedded .cotizador-card {
  padding: 0.9rem 1rem !important;
}
.cotizador-viaje.is-embedded .title-cotizador {
  font-size: clamp(1.65rem, 2.5vw, 2rem);
  margin-bottom: 0.8rem !important;
}
.cotizador-viaje.is-embedded .form-row {
  --bs-gutter-x: 0.7rem;
  margin-bottom: 0.45rem !important;
}
.cotizador-viaje.is-embedded .btn-cotizar {
  font-size: 0.95rem;
  padding: 0.38rem 0.9rem;
}
.cotizador-viaje.is-embedded .form-floating > .form-control-sm,
.cotizador-viaje.is-embedded .form-floating > .form-select-sm {
  font-size: 0.83rem;
  height: calc(1.25em + 0.85rem + 2px);
  min-height: calc(1.25em + 0.85rem + 2px);
  padding: 0.75rem 0.62rem 0.28rem 0.62rem;
}
.cotizador-viaje.is-embedded .form-floating > label {
  font-size: 0.74rem;
  padding: 0.55rem 0.62rem;
}
.cotizador-viaje.is-embedded .dropdown .btn-sm {
  height: calc(1.25em + 0.85rem + 2px);
  font-size: 0.83rem;
}
.cotizador-viaje.is-embedded ::v-deep .dp__input {
  font-size: 0.83rem;
}
.cotizador-viaje.is-embedded ::v-deep .dp__icon {
  width: 0.72rem;
  height: 0.72rem;
}
.form-select, .form-control {
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
}
.custom-tooltip {
  --bs-tooltip-bg: var(--bd-violet-bg);
  --bs-tooltip-color: var(--bs-white);
}

.btn-zebra {
  background-color: #32A5AB;
  color: white;
}

.dropdown-menu {
  background-color: white;
  border: 1px solid #ced4da;
}

.bg-zebra {
  background-color: #f8f9fa;
}

.custom-tooltip {
  --bs-tooltip-bg: #32A5AB;
  --bs-tooltip-color: white;
}

@media (max-width: 768px) {
  .w-75 {
    width: 100%;
  }
}
::v-deep .dp--active {
  background-color: #2c5282 !important;
}
.form-floating > .form-control:disabled + label,
.form-floating > .form-control-plaintext + label {
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
::v-deep .dp__theme_light {
  --dp-font-size: 0.75rem; 
  --dp-cell-border-radius: 2px;
  --dp-menu-padding: 0.5rem;
}
::v-deep .dp__menu_content {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem; 
}
::v-deep .dp__cell_inner,
::v-deep .dp__calendar_header_item {
  width: 25px;
  height: 25px; 
  line-height: 25px;
  font-size: 0.75rem; 
}
::v-deep .dp__cell_inner {
  padding: 0; 
}
::v-deep .dp__action_button {
  font-size: 0.7rem;
  padding: 0.1rem 0.4rem;
}
::v-deep .dp__icon {
  width: 0.8rem;
  height: 0.8rem;
}
::v-deep .dp__month_year_select {
    font-size: 0.8rem;
}
::v-deep .dp__footer {
  padding: 0.25rem;
}
::v-deep .dp__action_buttons {
  gap: 0.5rem; 
}
</style>
